export const REGISTRATION_STATUS_PENDING = "PENDING";
export const REGISTRATION_STATUS_APPROVED = "APPROVED";
export const REGISTRATION_STATUS_CANCELLED = "CANCELLED";

export const REGISTRATION_STATUS_OPTIONS = [
    { value: REGISTRATION_STATUS_PENDING, label: `${REGISTRATION_STATUS_PENDING}` },
    { value: REGISTRATION_STATUS_APPROVED, label: `${REGISTRATION_STATUS_APPROVED}` },
    { value: REGISTRATION_STATUS_CANCELLED, label: `${REGISTRATION_STATUS_CANCELLED}` },
];